import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { render } from 'react-dom';
import LawdocsSaveButton from './LawdocsSaveButton';
import DocumentButton from './DocumentButton';
import DeleteDocumentButton from './ButtonDelete';
import DocumentUploadButton from './DocumentUploadButton';
import T from '../../app2/Utils/Locale';
const documentButtons = document.getElementsByName('document_button');
documentButtons.forEach((documentButton) => {
    render(_jsx(DocumentButton, { document: JSON.parse(documentButton.getAttribute('data-document')), path: documentButton.getAttribute('data-path'), action: documentButton.getAttribute('data-action'), statusText: documentButton.getAttribute('data-status-text'), waitingForPaymentBasketId: documentButton.getAttribute('data-basket-waiting-for-payment'), isNemIdValidated: documentButton.getAttribute('data-is-nem-id-validated') === '1' }), documentButton);
});
const lawdocsSaveButtons = document.getElementsByName('lawdocs_save_button');
lawdocsSaveButtons.forEach((lawdocsSaveButton) => {
    render(_jsx(LawdocsSaveButton, { user: JSON.parse(lawdocsSaveButton.getAttribute('data-user')) }), lawdocsSaveButton);
});
const documentDeleteButtons = document.getElementsByName('document_delete_button');
documentDeleteButtons.forEach((documentDeleteButton) => {
    render(_jsxs(DeleteDocumentButton, Object.assign({ document: JSON.parse(documentDeleteButton.getAttribute('data-document')) }, { children: [_jsx("i", { className: 'far fa-trash-alt' }), _jsx("p", { children: T('utils.delete') })] })), documentDeleteButton);
});
const documentUploadButtons = document.getElementsByName('document_upload_button');
documentUploadButtons.forEach((documentUploadButton) => {
    render(_jsx(DocumentUploadButton, { products: JSON.parse(documentUploadButton.getAttribute('data-products')), title: documentUploadButton.getAttribute('data-title'), classes: documentUploadButton.getAttribute('data-classes') }), documentUploadButton);
});
